"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomLoaderMessage = exports.CustomLoaderRange = exports.CustomLoaderTrack = exports.CustomLoaderCount = exports.Container = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../theme/colors");
exports.Container = styled_components_1.default.div `
  width: 100%;
`;
exports.CustomLoaderCount = styled_components_1.default.div `
  width: 100%;
  margin: 15px 0;
  text-align: center;
`;
exports.CustomLoaderTrack = styled_components_1.default.div `
  position: relative;
  height: 12px;
  background-color: ${colors_1.GREY4};
  width: 100%;
  z-index: 1;
`;
exports.CustomLoaderRange = styled_components_1.default.div `
  position: absolute;
  height: 12px;
  background-color: ${colors_1.DARK_GREEN};
  z-index: 2;
  width: ${(props) => props.$count}%;
  transition: width 1s linear;
`;
exports.CustomLoaderMessage = styled_components_1.default.div `
  margin: 10px 0 0;
  text-align: center;
`;
//# sourceMappingURL=CustomLoader.styles.js.map